import BaseCtrl from 'edge/platform/base/BaseCtrl';
import slideContent from 'text!edge/platform/widgets/carousel/config/demoslides.json';

var fn = function fn($scope, landingPageContent) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.content = landingPageContent;
        $scope.slideContent = JSON.parse(slideContent);
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', 'landingPageContent'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/demolandingpage/controllers/LandingPageCtrl.js
// module id = 1068
// module chunks = 0